export const COMPANY_ROUTE_NAMES = {
  COMPANY_DASHBOARD: 'company-dashboard',
  DISCUSSIONS: 'discussions',
  MESSAGES: 'messages',
};
